/* eslint-disable */
import React, { Component } from "react";

export default class Footer extends Component {
  render() {
    return (
      <footer className="footer-main footer2">
        <div className="container-fluid">
          <div className="row">
            <div className="col m5 left-align term-cond1-footer">
              <ul>
                <li>
                  <a href="https://mycounto.com/terms/" target="_blank">
                    Terms of service{" "}
                  </a>{" "}
                </li>
                <li>
                  <a href="https://mycounto.com/privacy-policy/" target="_blank">
                    {" "}
                    privacy policy{" "}
                  </a>{" "}
                </li>
              </ul>
            </div>
            <div className="col m6 left-align ">
              <span className="copy-c">©</span> 2023. Xion.AI Pte Limited. All
              rights reserved{" "}
            </div>
          </div>
        </div>
      </footer>
    );
  }
}
